<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import './assets/sass/custom.scss'
import './assets/scss/custom.scss'
import 'vue-notifyjs/themes/now-ui.scss'

export default {
  name: 'app'
}
</script>
